import { render, staticRenderFns } from "./DropdownWithRadioButtons.vue?vue&type=template&id=b648147a&scoped=true&"
import script from "./DropdownWithRadioButtons.vue?vue&type=script&lang=ts&"
export * from "./DropdownWithRadioButtons.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownWithRadioButtons.vue?vue&type=style&index=0&id=b648147a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b648147a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VDivider,VIcon,VListItem,VRadio,VRadioGroup})
